import { useReducer } from 'react';
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import reducer, { defaultState, updateFieldCreator } from '../Add/reducer';
import {
  updateMaCisCreator,
  setMaCisEditErrorsCreator,
  loadMaCisDetailsCreator,
} from '../../../../../store/actionsCreators';
import EditChangeRequest from '../../../../../shared/ChangeRequest/Edit/EditChangeRequest';

const EditMaChangeRequest = ({ errors, updateChangeRequest, removeError, profile }) => {
  const [state, dispatch] = useReducer(reducer, defaultState);

  return (
    <EditChangeRequest
      state={state}
      dispatch={dispatch}
      updateFieldCreator={updateFieldCreator}
      errors={errors}
      updateChangeRequest={updateChangeRequest}
      removeError={removeError}
      profile={profile}
      type="ma"
    />
  );
};

EditMaChangeRequest.propTypes = {
  errors: PropTypes.shape({
    description: PropTypes.string,
    files: PropTypes.string,
  }),
  updateChangeRequest: PropTypes.func.isRequired,
  removeError: PropTypes.func.isRequired,
  profile: PropTypes.object,
};

EditMaChangeRequest.defaultProps = {
  errors: {},
  profile: {},
};

const mapStateToProps = ({ ma }) => ({
  errors: ma.cis.changeRequests.editErrors,
  profile: ma.cis.changeRequests.profile,
});

const mapDispatchToProps = (dispatch) => ({
  updateChangeRequest: (id, payload, history) =>
    dispatch(updateMaCisCreator(id, 'changeRequests', payload, history, true)),
  removeError: (payload) => dispatch(setMaCisEditErrorsCreator('changeRequests', payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(EditMaChangeRequest);
